/** 工单提单来源 order_submit_source */
export const ORDER_SUBMIT_SOURCE = {
  NORMAL: 2, // 普通工单
  SMART: 3, // 智能工单
  SELF_SERVICE: 4, // 自助表单
  ACCOUNT_DELETE_PASSPORT: 5 // 账号删除（用户中心入口）
};
